import React from "react";

import { ExportButtonGraphql } from "components/actions/ExportButtonGraphql";
import { SpendFilters } from "lib/hooks/api/spend/spendFilters";
import { useExportSpend } from "lib/hooks/api/spend/useExportSpend";
import { EventDataTypes } from "lib/tracking";
import { SpendExportGroupBy } from "lib/types/graphQLEnums";
import { TransactionSort } from "./hooks/useTransactionsTable";

// Must match the backend export cap (SpendExportService.MAX_ROWS) so the button
// blocks oversized exports client-side rather than letting the backend silently
// truncate them. Raise both together if the cap changes.
const SPEND_EXPORT_LIMIT = 50_000;

function ExportDataButton({
  filters,
  totalRows,
  groupBy = SpendExportGroupBy.None,
  className,
  isLoadingTotalRows = false,
  sort,
}: {
  filters: SpendFilters;
  totalRows?: number;
  groupBy?: SpendExportGroupBy;
  className?: string;
  /** Disables the button, for while the filters are still being assembled. */
  isLoadingTotalRows?: boolean;
  /** The transactions table's order, so the file matches it. Summaries ignore it. */
  sort?: TransactionSort;
}) {
  const exportMutation = useExportSpend();

  return (
    <span className={className}>
      <ExportButtonGraphql
        exportMutation={exportMutation}
        exportVariables={{ request: { filters, groupBy, ...sort } }}
        totalResults={totalRows ?? 0}
        isLoadingTotalResults={isLoadingTotalRows}
        exportDataType={EventDataTypes.spend}
        exportLimit={SPEND_EXPORT_LIMIT}
      />
    </span>
  );
}

export default ExportDataButton;
